import { isMobileApplication } from 'effects/auth';
import { RootState } from 'reducers/rootReducer';
import { PayloadAction } from 'types/payloadAction';

// Action Types
const NAME = 'numpadModal';

const HIDE = `${NAME}/HIDE`;
const SHOW_FULL = `${NAME}/SHOW_MAX`; // Show modal with numpad
const SHOW_MIN = `${NAME}/SHOW_MIN`; // Show modal without numpad
const TOGGLE = `${NAME}/TOGGLE`; // Toggle between min and max

export interface NumpadModalState {
  readonly isShowing: boolean;
  readonly doShowNumpad: boolean;
}

// Initial State
const initialState: NumpadModalState = {
  isShowing: isMobileApplication() && true,
  doShowNumpad: isMobileApplication(),
};

// Action Creators
export const actions = {
  hide: () => ({ type: HIDE }),
  show: () => ({ type: SHOW_FULL }),
  showMin: () => ({ type: SHOW_MIN }),
  toggle: () => ({ type: TOGGLE }),
};

// Selectors
const getNumpadModal = (rootState: RootState): NumpadModalState => rootState.numpadModal;

const isShowing = (rootState: RootState): boolean => getNumpadModal(rootState).isShowing;
const doesShowNumpad = (rootState: RootState): boolean => getNumpadModal(rootState).doShowNumpad;

export const selectors = {
  isShowing,
  doesShowNumpad
};

// Reducers

// Remove Modal from Display
const hideReducer = (state: NumpadModalState): NumpadModalState => ({
  ...state,
  isShowing: false,
});

// Show Modal with the Numpad displayed
const showFullReducer = (state: NumpadModalState): NumpadModalState => ({
  ...state,
  isShowing: true,
  doShowNumpad: true,
});

// Show Modal without the numpad; includes only the text input
const showMinReducer = (state: NumpadModalState): NumpadModalState => ({
  ...state,
  isShowing: true,
  doShowNumpad: false,
});

const showToggleReducer = (state: NumpadModalState): NumpadModalState => ({
  ...state,
  doShowNumpad: !state.doShowNumpad,
});


export const reducer = (
  state: NumpadModalState = initialState,
  action: PayloadAction,
): NumpadModalState => {
  switch (action.type) {
    case HIDE:
      return hideReducer(state);

    case SHOW_FULL:
      return showFullReducer(state);

    case SHOW_MIN:
      return showMinReducer(state);

    case TOGGLE:
      return showToggleReducer(state);

    default:
      return state;
  }
};
